import { axios } from "../axios";
import { GET } from "../endpoints";

// GET /employee/lookups -> { polarities, feelings, reasons }
export const getLookups = async (data) => {
  try {
    let response = await axios.get(GET.GET_LOOKUPS, {
      params: data,
    });
    return response;
  } catch (err) {
    throw err;
  }
};

// GET /employee/feelings -> ordered feelings array
export const getFeelings = async (data) => {
  try {
    let response = await axios.get(GET.GET_FEELINGS, {
      params: data,
    });
    return response;
  } catch (err) {
    throw err;
  }
};

// GET /employee/reasons -> ordered reasons array
export const getReasons = async (data) => {
  try {
    let response = await axios.get(GET.GET_REASONS, {
      params: data,
    });
    return response;
  } catch (err) {
    throw err;
  }
};
